// extracted by mini-css-extract-plugin
export var arrow = "_2h-6";
export var changeItem = "_2h-3";
export var changesHeader = "_2h-1";
export var changesList = "_2h-2";
export var container = "_2h-0";
export var pathLabel = "_2h-4";
export var value = "_2h-7";
export var valuesContainer = "_2h-5";